import { Typography } from 'modules/ui';

import styles from './Table.module.scss';

type TableFiltersToolbarProps = {
    activeFiltersCount: number;
    onClearFilters: () => void;
    t: (key: string, options?: { count?: number }) => string;
};

export const TableFiltersToolbar = ({
    activeFiltersCount,
    onClearFilters,
    t,
}: TableFiltersToolbarProps) => (
    <div className={styles.filtersToolbar}>
        <Typography variant="p" className={styles.filtersCounter}>
            {t('table.activeFilters', { count: activeFiltersCount })}
        </Typography>
        <button className={styles.cancelFiltersButton} onClick={onClearFilters} type="button">
            {t('table.resetFilters')}
        </button>
    </div>
);
